export default __webpack_public_path__ + "static/media/play-stop.64c318b8.svg";